const steps =
{
    title  : 'Étape',
    titleX : 'Étapes'
};

export default steps ;
